// Maps complexity UI value → API complexity array values
const COMPLEXITY_VALUES: Record<string, Array<string>> = {
  easy: ['1'],
  medium: ['2', '3'],
  hard: ['4', '5'],
};

// Options passed to the search API to request facet data per type
// priceGroup excluded from Product facets — needs backend work
export const SEARCH_OPTIONS: Record<string, Record<string, Array<string>>> = {
  Product: {
    facets: [
      'categories',
      'apparelFit',
      'apparelSize',
      'features',
      'grillCompatibility',
      'grillSeries',
      'pairings',
    ],
  },
  Recipe: {
    facets: ['mealType', 'complexity', 'hardwood', 'holiday', 'cookingMethod', 'diet'],
  },
  Learn: {
    facets: ['categories', 'tags', 'featuredContent'],
  },
};

// Product/Recipe filter key arrays for buildFilter
// priceGroup excluded from Product — needs backend work
const PRODUCT_FILTER_KEYS = [
  'categories',
  'grillSeries',
  'color',
  'apparelFit',
  'apparelSize',
  'features',
  'grillCompatibility',
  'pairings',
];
const RECIPE_FILTER_KEYS = [
  'relatedCategories',
  'cookingMethod',
  'mealType',
  'hardwood',
  'holiday',
  'diet',
];
const LEARN_FILTER_KEYS = ['categories', 'tags'];

/**
 * Builds the search API filter object for the given search type from the active URL filters.
 * @param searchType - The active search type (Product, Recipe, ...)
 * @param activeFilters - Active filter values keyed by filter key
 * @returns The filter object, or undefined when no applicable filters are active
 */
export const buildFilter = (
  searchType: string,
  activeFilters: Record<string, Array<string>>,
): Record<string, unknown> | undefined => {
  const filter: Record<string, unknown> = {};

  if (searchType === 'Product') {
    for (const key of PRODUCT_FILTER_KEYS) {
      if (activeFilters[key]?.length) filter[key] = activeFilters[key];
    }
  } else if (searchType === 'Recipe') {
    for (const key of RECIPE_FILTER_KEYS) {
      if (activeFilters[key]?.length) filter[key] = activeFilters[key];
    }
    const complexity = activeFilters.complexity?.[0];
    if (complexity) filter.complexity = COMPLEXITY_VALUES[complexity] ?? [];
  } else if (searchType === 'Learn') {
    for (const key of LEARN_FILTER_KEYS) {
      if (activeFilters[key]?.length) filter[key] = activeFilters[key];
    }
    const featuredContent = activeFilters.featuredContent?.[0];
    if (featuredContent !== undefined) filter.featuredContent = featuredContent === 'true';
  }

  return Object.keys(filter).length > 0 ? filter : undefined;
};
